import {combineReducers} from "redux";
import create from './create';
import deleteGender from './delete';
import deleteSelection from "./deleteSelection";
import list from "./list";
import update from './update';
import updatePosition from "./updatePosition";

export default combineReducers({ create, deleteGender, deleteSelection, list, update, updatePosition });
